export const aaaCustomColors = {
    primary: "#ed7226",
    primaryDark: "#d45c11",
    primaryLight: "#fdf1e9",
    secondary: "#0f152b",
    error: "#ea4848",
    errorBackground: "#fdeded",
    white: "#ffffff",
    borderColor: "#ededed",
    fieldBackgroundColor: "#ededed",
    middleGrey: "#B4B8B8",
    dataUploadBorderColor: "#B4B8B8",
    disabledElements: "#4f4f4f",
    profileGrey: "#c4c4c4",
    headingsDark: "#121212",
    body1Dark: "#5a5a5a",
    body2Dark: "#9b9b9b",
    backgroundLight: "#F9F9F9",
    evidenceBackground: "#CFFFF6",
    evidenceForeground: "#3F897C",

    hoverColor: "rgba(0, 0, 0, 0.04)",

    cardYellow: "rgba(253, 242, 215, 0.5)",
    cardRed: "#fdeded",

    preferred: "#FFEECA",
    confirmed: "#E2F3D0",

    sideBarDone: "#0f152b",
    sideBarMissing: "#B4B8B8",
    sideBarCurrent: "#ed7226",

    darkPrimary: "#ffffff",
    darkSecondary: "#ffffff",
    darkTertiary: "#c4c4c4",
    darkForeground: "#ffffff",

    robotBorder: "#d45c11",
    robotBackground: "#fdf1e9",
    robotBackgroundWhite: "#ffffff",

    pmShade1: "#FDF2D7",
    pmPrimary: "#FFBE16",
    pmShade2: "#CC9300",
    qaShade1: "#EDCEBC",
    qaPrimary: "#ED7226",
    qaShade2: "#D45C11",
    trainingShade1: "#FFDDE3",
    trainingPrimary: "#FF4D6D",
    trainingShade2: "#C9184A",
    iOSShade1: "#CEEDF1",
    iOSPrimary: "#46A5DB",
    iOSShade2: "#2582B7",
    androidShade1: "#E2F3D0",
    androidPrimary: "#86CB95",
    androidShade2: "#2EA34F",
    flutterShade1: "#C4D3AE",
    flutterPrimary: "#6B7D4F",
    flutterShade2: "#49553E",
    unsolicitedShade1: "#b8cccc",
    unsolicitedPrimary: "#709999",
    unsolicitedShade2: "#115555",

    graphicShade1: "#FFEECA",
    graphicPrimary: "#FFBB11",
    graphicShade2: "#CE970C",
    uiuxShade1: "#E4FAFF",
    uiuxPrimary: "#73DCF6",
    uiuxShade2: "#149FC3",
    webShade1: "#CDE7EA",
    webPrimary: "#13828B",
    webShade2: "#0C3B3F",
    motionShade1: "#D9F9F2",
    motionPrimary: "#6EEFD6",
    motionShade2: "#2F8B7D",
    operationsShade1: "#F5C7C4",
    operationsPrimary: "#EF766E",
    operationsShade2: "#A54640",
    contentCreationShade1: "#E2F3D0",
    contentCreationPrimary: "#86CB95",
    contentCreationShade2: "#2EA34F",
    apprenticeShade1: "#EDCEBC",
    apprenticePrimary: "#ED7226",
    apprenticeShade2: "#D45C11",
    backendShade1: "#C4D3AE",
    backendPrimary: "#6B7D4F",
    backendShade2: "#49553E",
    fullStackShade1: "#FFDDE3",
    fullStackPrimary: "#FF4D6D",
    fullStackShade2: "#C9184A",
    frontEndShade1: "#CDE7EA",
    frontEndPrimary: "#13828B",
    frontEndShade2: "#0C3B3F"
};
